import { Box, Paper } from '@mui/material';
import './ScannerAnimation.css';
import {
  pipelineCardSx,
  pipelineUrlFeedColumnSx,
} from './ScannerAnimation.styles';
import { ScannerColumn } from './ScannerColumn';
import { ColumnLabel } from './SharedComponents';
import { TechColumn } from './TechColumn';
import { UrlFeed } from './UrlFeed';
import { usePipelineAnimation } from './usePipelineAnimation';

export default function ScannerAnimation() {
  const {
    urlRows,
    currentHost,
    codeLines,
    scanOffset,
    flashingLines,
    hitLines,
    beamFlash,
    techsForSite,
    detectedTechs,
    viewportRef,
  } = usePipelineAnimation();

  return (
    <Paper elevation={0} sx={pipelineCardSx}>
      {/* Column 1 — URL Feed */}
      <Box sx={pipelineUrlFeedColumnSx}>
        <ColumnLabel>20+ Million Websites</ColumnLabel>
        <UrlFeed rows={urlRows} />
      </Box>

      {/* Column 2 — Scanner */}
      <ScannerColumn
        currentHost={currentHost}
        codeLines={codeLines}
        scanOffset={scanOffset}
        flashingLines={flashingLines}
        hitLines={hitLines}
        beamFlash={beamFlash}
        viewportRef={viewportRef}
      />

      {/* Column 3 — Tech badges */}
      <TechColumn techsForSite={techsForSite} detectedTechs={detectedTechs} />
    </Paper>
  );
}
